import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class CustomMatPaginatorIntl extends MatPaginatorIntl {

  constructor(private translate: TranslateService) {
    super();
    this.translate.onLangChange.subscribe(() => {
      this.updateLabels(); 
    });
    this.updateLabels(); 
  }

  private updateLabels(): void {
    this.itemsPerPageLabel = this.translate.instant('COMMON_LABELS.ITEMS_PER_PAGE');
    this.nextPageLabel = this.translate.instant('COMMON_LABELS.NEXT_PAGE');
    this.previousPageLabel = this.translate.instant('COMMON_LABELS.PREVIOUS_PAGE');
    this.firstPageLabel = this.translate.instant('COMMON_LABELS.FIRST_PAGE');
    this.lastPageLabel = this.translate.instant('COMMON_LABELS.LAST_PAGE');
    this.changes.next(); // Notify components about the label changes
  }
  
}